/** 臻有钱-臻系列卡-权益入口 */
export const RIGHTS_ENTER = 'finance_loan_packageEntry';

/** 臻有钱-臻系列卡-权益入口-引导支付详情弹窗 */
export const RIGHTS_DETAIL_POPUP = 'finance_loan_packageEntry_DetailPopup';

/** 臻有钱-臻系列卡-权益入口-点击查看协议 */
export const RIGHTS_AGREEMENT = 'finance_loan_packageEntry_agreement';

/** 臻有钱-臻系列卡-权益入口-勾选协议按钮 */
export const RIGHTS_AGREEMENT_CHECK = 'finance_loan_packageEntry_agreementCheck';

/** 臻有钱-臻系列卡-权益入口-引导支付详情弹窗_底部按钮 */
export const RIGHTS_DETAIL_POPUP_BUTTON = 'finance_loan_packageEntry_DetailPopup_BottomButton';

/** 臻有钱-协议直接展示的样式，点击开通按钮 */
export const RIGHTS_DETAIL_DETAIL_OPEN = 'finance_member_packageDetail_open';
